import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import type { Call } from "@modules/Call/Voximplant/common/utils/sdk"

interface CallState {
    currentCall: Call | null
}

const initialState: CallState = {
    currentCall: null,
}

const callSlice = createSlice({
    name: "call",
    initialState,
    reducers: {
        changeCall(state, action: PayloadAction<Call | null>) {
            state.currentCall = action.payload
        },
        clearCall(state) {
            state.currentCall = null
        },
    },
})

export const callReducer = callSlice.reducer
export const { changeCall, clearCall } = callSlice.actions
